import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Award, Loader2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ReferrerSummary } from "./types";
import { formatCentsAdmin } from "./helpers";

export function ReferHostReferrersPanel() {
  const query = useQuery<ReferrerSummary[]>({
    queryKey: ["/api/admin/refer-host/referrers"],
    queryFn: async () => {
      const res = await fetch("/api/admin/refer-host/referrers", { credentials: "include" });
      if (!res.ok) throw new Error("Failed");
      return res.json();
    },
  });
  const referrers = query.data || [];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Award className="h-5 w-5 text-amber-500" />
          All Referrers
        </CardTitle>
      </CardHeader>
      <CardContent>
        {query.isLoading ? (
          <div className="flex items-center gap-2 text-muted-foreground py-8 justify-center">
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading...
          </div>
        ) : referrers.length === 0 ? (
          <p className="text-muted-foreground text-center py-8">No referrers yet.</p>
        ) : (
          <Table data-testid="table-refer-host-referrers">
            <TableHeader>
              <TableRow>
                <TableHead>Email</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Referrals</TableHead>
                <TableHead>Total Accrued</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {referrers.map((r, i) => (
                <TableRow key={`${r.type}-${r.id}`} data-testid={`row-referrer-${i}`}>
                  <TableCell className="font-medium">{r.email}</TableCell>
                  <TableCell className="text-muted-foreground text-sm">{r.name}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className="capitalize">{r.type === "user" ? "App User" : "Partner"}</Badge>
                  </TableCell>
                  <TableCell>{r.referralCount}</TableCell>
                  <TableCell className="font-medium text-green-700">{formatCentsAdmin(r.totalAccruedCents)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
